import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth';
import { useT } from '../i18n';
import Wordmark from '../components/Wordmark';
import Notice from '../components/Notice';

export default function Login() {
  const { signIn } = useAuth();
  const { t } = useT();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await signIn(username, password); }
    catch (err) { setError((err as Error).message); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-dvh flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="card w-full max-w-sm p-6 space-y-5">
        <div className="pt-2 pb-1"><Wordmark size="lg" /></div>
        <p className="text-dim text-sm">{t('login.blurb')}</p>
        <div>
          <label className="label" htmlFor="username">{t('login.identifier')}</label>
          <input id="username" autoComplete="username" autoCapitalize="none" autoCorrect="off" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div>
          <label className="label" htmlFor="password">{t('login.password')}</label>
          <input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <Notice kind="error">{error}</Notice>}
        <button className="btn-primary w-full" disabled={busy}>{busy ? t('login.busy') : t('login.submit')}</button>
        <Link to="/forgot" className="block text-center text-sm text-dim hover:text-chalk">{t('login.forgot')}</Link>
      </form>
    </div>
  );
}
